import { useState, ChangeEvent } from 'react';
import { useParams } from 'react-router';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { DocumentLibraryType } from './document-library.types';
import DocumentLibraryTabPanels from './DocumentLibraryTabPanels';
import styles from './DocumentLibraryTabs.module.css';
import { useMigrationStatus } from 'shared/custom-hooks/useMigrationStatus';
import { useSelector } from 'react-redux';
import { selectSelectedCompany } from 'companies/companies.slice';
import { shouldHide } from 'shared/utils/migration-utils';
import { MigrationOptions } from 'client-migration/clientMigration.types';

const tabTypeMap: Map<DocumentLibraryType, string> = new Map([
  [ 'forms', 'FORMS' ],
  [ 'legal', 'LEGAL' ],
  [ 'education', 'EDUCATION' ],
]);

function DocumentLibraryTabs() {
  let documentLibraryTabs = [ 'forms', 'legal', 'education' ] as DocumentLibraryType[];
  const { tab } = useParams<{tab?: DocumentLibraryType;}>();
  const [ activeTab, setActiveTab ] = useState<DocumentLibraryType>(tab ?? documentLibraryTabs[0]);
  const { hasMigrated, status } = useMigrationStatus();
  const selectedCompany = useSelector(selectSelectedCompany);

  if (shouldHide(status, hasMigrated, MigrationOptions.cdhOnly, selectedCompany)) {
    documentLibraryTabs = documentLibraryTabs.filter((documentLibraryType) => {
      return !(documentLibraryType === 'forms' || documentLibraryType === 'legal');
    });

    if (activeTab === 'forms' || activeTab === 'legal') {
      setActiveTab(documentLibraryTabs[0]);
    }
  }

  function onChangeTab(e: ChangeEvent<{}>, newTab: DocumentLibraryType) {
    if (newTab !== activeTab) {
      setActiveTab(newTab);
    }
  }

  return (
    <div className="w-full">
      <Tabs
        indicatorColor="primary"
        textColor="primary"
        className="mb-4"
        value={activeTab}
        onChange={onChangeTab}
        classes={ { flexContainer: styles.tabsBottomBoder } }
      >
        {
          documentLibraryTabs.map((type) => (
            <Tab value={type} label={tabTypeMap.get(type)} key={`${type}-tab`} className="min-w-0 max-w-none" />
          ))
        }
      </Tabs>
      <DocumentLibraryTabPanels
        documentLibraryTypes={documentLibraryTabs}
        activeTab={activeTab}
      />
    </div>
  );
}

export default DocumentLibraryTabs;
